/** How an amount is chosen: a named serving × quantity, or plain grams/ml. */

export type ServingDef = { label: string; grams: number; default?: boolean }
export type ServingOption = { label: string; grams: number; unit: boolean }

export function servingOptions(food: { basis?: string | null; servings?: ServingDef[] | null; nominal?: boolean }): ServingOption[] {
  const named = [...(food.servings ?? [])]
    .filter((s) => s.grams > 0 && s.label)
    .sort((a, b) => Number(!!b.default) - Number(!!a.default))
    .map((s) => ({ label: s.label, grams: s.grams, unit: false }))
  // A nominal weight is bookkeeping, not a real weight: offering grams would
  // let someone log "300 g" of a burger against a made-up 500 g serving.
  if (food.nominal && named.length) return named
  const unit = food.basis === 'ml' ? 'ml' : 'g'
  return [...named, { label: unit, grams: 1, unit: true }]
}

export function gramsFor(opt: ServingOption, qty: number): number {
  return Math.round(opt.grams * qty * 10) / 10
}

export function defaultQty(opt: ServingOption): number {
  return opt.unit ? 100 : 1
}
